import type { GetSuggestionsDTO } from '../service/ai-translation.repository.interface';
import type { GetSuggestionsRequest, SuggestionItem } from '../type/ai-translation.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { GetSuggestions } from '@/infrastructure/api-functions/interface/get-suggestions.interface';

@injectable()
export class GetSuggestionsDTOImpl implements GetSuggestionsDTO {
    constructor(
        @inject(GetSuggestions)
        private readonly _getSuggestionsApi: GetSuggestions,
    ) { }

    async fetch(value: GetSuggestionsRequest): Promise<SuggestionItem[]> {
        const params = {
            input: value.input,
            tech_topic: value.techTopic,
            target_lang: value.targetLang,
            source_lang: value.sourceLang,
            task_id: value.taskId,
            current_step: value.currentStep,
        };
        return await this._getSuggestionsApi.getSuggestions(params);
    }
}
